import { useState } from "react";
import { X } from "lucide-react";

const IMAGES = [
  { src: "/images/interior-2.jpg", alt: "Tetőtéri közös tér", span: "lg:row-span-2" },
  { src: "/images/room-1.jpg", alt: "Munkaállomás", span: "" },
  { src: "/images/room-2.jpg", alt: "Tárgyaló sarok", span: "" },
  { src: "/images/interior-1.jpg", alt: "Belső tér", span: "lg:col-span-2" },
  { src: "/images/room-3.jpg", alt: "Csendes zug", span: "" },
  { src: "/images/room-4.jpg", alt: "Természetes fény", span: "" },
  { src: "/images/room-5.jpg", alt: "Munkahely részlet", span: "" },
  { src: "/images/room-6.jpg", alt: "Részlet", span: "" },
];

export default function Gallery() {
  const [open, setOpen] = useState(null);

  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="py-24 md:py-32 bg-white border-y border-[#E5E0D8]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-16 grid lg:grid-cols-12 items-end gap-8">
          <div className="lg:col-span-8">
            <p className="eyebrow mb-6">Galéria</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A1A1A]">
              Pillanatképek<br /><span className="italic">a térből.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 text-[#595959] text-[15px] leading-relaxed">
            A tetőtéri coworking szárny – természetes fény, fa felületek, csend.
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[200px] md:auto-rows-[260px] gap-3">
          {IMAGES.map((img, i) => (
            <button
              key={i}
              type="button"
              onClick={() => setOpen(img)}
              data-testid={`gallery-item-${i}`}
              className={`img-hover relative bg-[#FAF9F6] ${img.span}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-[#1A1A1A]/0 hover:bg-[#1A1A1A]/15 transition-colors duration-500" />
            </button>
          ))}
        </div>
      </div>

      {open && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[60] bg-[#1A1A1A]/90 backdrop-blur-sm flex items-center justify-center p-6"
          onClick={() => setOpen(null)}
        >
          <button
            data-testid="lightbox-close"
            className="absolute top-6 right-6 text-white p-2 hover:opacity-70"
            aria-label="Bezárás"
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={open.src}
            alt={open.alt}
            className="max-w-full max-h-[88vh] object-contain"
          />
        </div>
      )}
    </section>
  );
}
